import React from "react";
import { MaintenancePartAccordian } from "../../CommonComponent";
import "./maintenancepartlist.scss";
import { IMaintenancePartList } from "./maintenancepartlistinterface";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import Loader from "../../Loader";

const MaintenancePartList = (props: IMaintenancePartList) => {
    const { t } = useTranslation();
  return (
    <>
      <div className="maintenancePartlistfieldWrapper mt-4">
        <div className="maintenanceapart_title">
          <span>{t(RESOURCE.MyK_Label_ShoppingCart_Maintenance_Part_List)}</span>
              </div>
        <div className="maintenancePartInput">
          <div className="maintenancePartinputfields">
                 <div className="input-view mr-2 mb-sm-0 mb-3">
                 <div className="label">{t(RESOURCE.MyK_Label_Model)}</div>
                <div className="product-field">
                   <input type="text" className="text-input" onChange={(e) => { props.setMaintenancePartModel(e.target.value) }} />
              </div>
            </div>
            <div className="input-view mb-sm-0 mb-3">
              <div className="label">{t(RESOURCE.MyK_Label_Serial)} #</div>
              <div className="product-field">
                <input type="text" className="text-input" onChange={(e) => { props.setMaintenancePartSerial(e.target.value) }}/>
              </div>
            </div>
          </div>
        </div>
          </div>
           
          <div className="clearfix maintenanceAccordian">
              {props?.maintenancePartsList?.length == 0 && (!props.isMaintenancePartLoading) &&
                  <h4 className="text-center m-5">{t(RESOURCE.MyK_Label_ShoppingCart_No_Records_Available)}</h4>}
              {props?.maintenancePartsList?.map((item: any) =>
                  <MaintenancePartAccordian getMiningParts={props?.getMiningParts} onRefresh={props.onRefresh} maintenancePartsList={props?.maintenancePartsList} setMaintenancePartsList={props.setMaintenancePartsList} partNumberRedirect={props.partNumberRedirect} getCartItems={props.getCartItems} data={item} key={item.model + item.serial + item.unit} />
              )}
      </div>
    </>
  );
};

export default MaintenancePartList;
